/**
 * sortable creates the window.initSortable function with sortableTiles and sortableTableItems.
 *
 * Settings explanations:
 * - Start + helper function:    Make it so that the height of the placeholder is the same as the height of the complete dragging item. This is automatic in the case of a display:block or the like, but not in the case of ie a tbody element.
 * - ConnectWith:                Allows the user to move tiles between 'lists'.
 *
 * Dependencies
 * - jQuery UI Sortable
 *
 * See the drag-and-drop material for proper use and structure.
 */

function sortable() {
	const sortableTilesSelector = '.js-sortable-tiles';
	const sortableTableItemsSelector = '.js-sortable-tableitems';
	function sortableTiles(callback) {
		if ($(sortableTilesSelector).length == 0) {
			return;
		}

		$(sortableTilesSelector).sortable({
			revert: true,
			handle: '.js-sortable-tiles-handle',
			items: '> .js-sortable-tiles-item',
			connectWith: sortableTilesSelector,
			start: function(e, ui) {
				ui.placeholder.height(ui.helper.height());
			},
			helper: function(e, src) {
				return src;
			},
			stop: function() {
				window.resize();
				callback();
			}
		});
	}
	sortableTiles();

	function sortableTableItems(callback) {
		if ($(sortableTableItemsSelector).length == 0) {
			return;
		}

		$(sortableTableItemsSelector).sortable({
			revert: true,
			handle: '.js-sortable-tableitem-handle',
			items: '> tr.js-sortable-tableitems-item',
			stop: function() {
				window.resize();
				callback();
			}
		});
	}
	sortableTableItems();

	window.initSortable = function(callback) {
		if (callback == undefined) {
			callback = function() {};
		}
		sortableTiles(callback);
		sortableTableItems(callback);
	};
}
sortable();
